// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchMob_searchWrapper__jryR0","input":"SearchMob_input__JmAGK"};